module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SitePage"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('help', {
    attrs: {
      "reflink": "create-projects",
      "label": _vm.$t("projects.Create project")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ControlsRow"
  }, [_c('button', {
    staticClass: "btn __blue",
    on: {
      "click": _vm.addDemoProject
    }
  }, [_vm._v(_vm._s(_vm.$t("projects.Add demo project")))]), _vm._v("\n         \n      "), _c('button', {
    staticClass: "btn __blue",
    on: {
      "click": _vm.createNewProjectModal
    }
  }, [_vm._v(_vm._s(_vm.$t("projects.Create new project")))]), _vm._v("\n         \n      "), _c('button', {
    staticClass: "btn __blue",
    on: {
      "click": _vm.uploadProjectFromFile
    }
  }, [_vm._v(_vm._s(_vm.$t("projects.Upload project from file")))]), _vm._v("\n         \n      "), _c('button', {
    staticClass: "btn __blue",
    attrs: {
      "data-tooltip": _vm.$t('Last extracted 25 Mar 2024')
    },
    on: {
      "click": _vm.addCountryProject
    }
  }, [_vm._v(_vm._s(_vm.$t("Add country project from LiST database")))]), _vm._v("\n         \n    ")])], 1), _vm._v(" "), (_vm.projectSummaries.length > 0) ? _c('div', {
    staticClass: "PageSection"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('help', {
    attrs: {
      "reflink": "manage-projects",
      "label": _vm.$t("projects.Manage projects")
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterText),
      expression: "filterText"
    }],
    staticClass: "txbox",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.filterPlaceholder
    },
    domProps: {
      "value": (_vm.filterText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover table-striped",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelected),
      expression: "allSelected"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, null) > -1 : (_vm.allSelected)
    },
    on: {
      "click": function($event) {
        return _vm.selectAll()
      },
      "change": function($event) {
        var $$a = _vm.allSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelected = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    on: {
      "click": function($event) {
        return _vm.updateSorting('name')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("Name")) + "\n            "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortColumn == 'name' && !_vm.sortReverse),
      expression: "sortColumn == 'name' && !sortReverse"
    }]
  }, [_c('i', {
    staticClass: "fas fa-caret-down"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortColumn == 'name' && _vm.sortReverse),
      expression: "sortColumn == 'name' && sortReverse"
    }]
  }, [_c('i', {
    staticClass: "fas fa-caret-up"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortColumn != 'name'),
      expression: "sortColumn != 'name'"
    }]
  }, [_c('i', {
    staticClass: "fas fa-caret-up",
    staticStyle: {
      "visibility": "hidden"
    }
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t("projects.Project actions")))]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    staticStyle: {
      "text-align": "left"
    },
    on: {
      "click": function($event) {
        return _vm.updateSorting('updatedTime')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("projects.Last modified")) + "\n            "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortColumn == 'updatedTime' && !_vm.sortReverse),
      expression: "sortColumn == 'updatedTime' && !sortReverse"
    }]
  }, [_c('i', {
    staticClass: "fas fa-caret-down"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortColumn == 'updatedTime' && _vm.sortReverse),
      expression: "sortColumn == 'updatedTime' && sortReverse"
    }]
  }, [_c('i', {
    staticClass: "fas fa-caret-up"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortColumn != 'updatedTime'),
      expression: "sortColumn != 'updatedTime'"
    }]
  }, [_c('i', {
    staticClass: "fas fa-caret-up",
    staticStyle: {
      "visibility": "hidden"
    }
  })])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("projects.Language")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Databook")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedFilteredProjectSummaries), function(projectSummary) {
    return _c('tr', {
      class: {
        highlighted: projectSummary.project.id === _vm.projectID
      }
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (projectSummary.selected),
        expression: "projectSummary.selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(projectSummary.selected) ? _vm._i(projectSummary.selected, null) > -1 : (projectSummary.selected)
      },
      on: {
        "click": function($event) {
          return _vm.uncheckSelectAll()
        },
        "change": function($event) {
          var $$a = projectSummary.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(projectSummary, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(projectSummary, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(projectSummary, "selected", $$c)
          }
        }
      }
    })]), _vm._v(" "), (projectSummary.renaming !== '') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (projectSummary.renaming),
        expression: "projectSummary.renaming"
      }],
      staticClass: "txbox renamebox",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (projectSummary.renaming)
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.renameProject(projectSummary)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(projectSummary, "renaming", $event.target.value)
        }
      }
    })]) : _c('td', [(projectSummary.project.id === _vm.projectID) ? _c('div', [_c('b', [_vm._v(_vm._s(projectSummary.project.name))])]) : _c('div', [_vm._v("\n              " + _vm._s(projectSummary.project.name) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [(_vm.sortedFilteredProjectSummaries.length > 1) ? _c('span', [_c('button', {
      staticClass: "btn __green",
      attrs: {
        "disabled": projectSummary.project.id === _vm.projectID
      },
      on: {
        "click": function($event) {
          return _vm.openProject(projectSummary.project.id, false)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("Open")))])])]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t('Rename')
      },
      on: {
        "click": function($event) {
          return _vm.renameProject(projectSummary)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t('Copy')
      },
      on: {
        "click": function($event) {
          return _vm.copyProject(projectSummary.project.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-files"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t('Download')
      },
      on: {
        "click": function($event) {
          return _vm.downloadProjectFile(projectSummary.project.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-download"
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v("\n            " + _vm._s(projectSummary.project.updatedTimeString ? projectSummary.project.updatedTimeString : 'No modification') + "\n          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(projectSummary.project.localeName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "white-space": "nowrap",
        "text-align": "left"
      }
    }, [_c('button', {
      staticClass: "btn __blue",
      attrs: {
        "data-tooltip": _vm.$t("projects.Rename databook")
      },
      on: {
        "click": function($event) {
          return _vm.renameDatasetModal(projectSummary.project.id, projectSummary.selectedDataSet)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn __blue",
      attrs: {
        "data-tooltip": _vm.$t("projects.Copy databook")
      },
      on: {
        "click": function($event) {
          return _vm.copyDataset(projectSummary.project.id, projectSummary.selectedDataSet)
        }
      }
    }, [_c('i', {
      staticClass: "ti-files"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn __blue",
      attrs: {
        "data-tooltip": _vm.$t("projects.Delete databook")
      },
      on: {
        "click": function($event) {
          return _vm.deleteDataset(projectSummary.project.id, projectSummary.selectedDataSet)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn __blue",
      attrs: {
        "data-tooltip": _vm.$t("projects.Download databook")
      },
      on: {
        "click": function($event) {
          return _vm.downloadDatabook(projectSummary.project.id, projectSummary.selectedDataSet)
        }
      }
    }, [_c('i', {
      staticClass: "ti-download"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn __blue",
      attrs: {
        "data-tooltip": _vm.$t("projects.Upload databook")
      },
      on: {
        "click": function($event) {
          return _vm.uploadDatabook(projectSummary.project.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-upload"
    })]), _vm._v(" "), (projectSummary.project.dataSets.length > 0) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (projectSummary.selectedDataSet),
        expression: "projectSummary.selectedDataSet"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(projectSummary, "selectedDataSet", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((projectSummary.project.dataSets), function(dataset) {
      return _c('option', [_vm._v("\n                " + _vm._s(dataset) + "\n              ")])
    }), 0) : _vm._e(), _vm._v(" \n          ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "ControlsRow"
  }, [_c('button', {
    staticClass: "btn __red",
    attrs: {
      "disabled": !_vm.anySelected
    },
    on: {
      "click": function($event) {
        return _vm.deleteModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("Delete selected")))]), _vm._v("\n           \n        "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": !_vm.anySelected
    },
    on: {
      "click": _vm.downloadSelectedProjects
    }
  }, [_vm._v(_vm._s(_vm.$t("Download selected")))])])], 1)]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "create-project",
      "height": "auto",
      "classes": ['v--modal', 'vue-dialog'],
      "width": 400,
      "pivot-y": 0.3,
      "adaptive": true,
      "clickToClose": false
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("projects.Create blank project")) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-c-text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("projects.Project name")) + ":"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proj_name),
      expression: "proj_name"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.proj_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proj_name = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('button', {
    staticClass: "btn __green",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.createNewProject()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Create")) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn __red",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('create-project')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Cancel")) + "\n        ")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "rename-dataset",
      "height": "auto",
      "classes": ['v--modal', 'vue-dialog'],
      "width": 400,
      "pivot-y": 0.3,
      "adaptive": true,
      "clickToClose": false
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("projects.Rename databook")) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-c-text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("projects.New name")) + ":"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalRenameDataset),
      expression: "modalRenameDataset"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.modalRenameDataset)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalRenameDataset = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('button', {
    staticClass: "btn __green",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.renameDataset()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Rename")) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn __red",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('rename-dataset')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Cancel")) + "\n        ")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "country-proj",
      "height": "auto",
      "classes": ['v--modal', 'vue-dialog'],
      "width": 400,
      "pivot-y": 0.3,
      "adaptive": true,
      "clickToClose": false
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("Select country")) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-c-text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("projects.list_data_warning")) + "\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre"
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countryList), function(entry) {
    return _c('option', {
      domProps: {
        "value": entry
      }
    }, [_vm._v("\n            " + _vm._s(entry.name) + "\n          ")])
  }), 0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('button', {
    staticClass: "btn __green",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        _vm.loadCountryProj(_vm.country);
        _vm.$modal.hide('country-proj')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Load")) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn __red",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('country-proj')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Cancel")) + "\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34afb630","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/ProjectsPage.vue
// module id = 370
// module chunks = 1